export default {"src":"/_next/static/media/businesses-ready-get-started-illustration.26633989.svg","height":558,"width":631,"blurWidth":0,"blurHeight":0};